// extracted by mini-css-extract-plugin
export var divider = "_40-0";
export var dividerText = "_40-1";